import { _axios } from '@/plugins/axios';

const dependencyTrackResource = '/api/v1/dependency-track';

export default {
  importSbom: fileName => _axios.post(`${dependencyTrackResource}/bom/${fileName}`),
};
